module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr22-3d59947884b9752eef149bd30473485a.jpg";